import { getCookie } from '@/helpers/cookies'

export interface SpainLaunchParameters {
  credentials: string | undefined
  token: string
  market: string
  language: string
}

export function getSpainLaunchParameters(): SpainLaunchParameters | undefined {
  const searchParameters = new URLSearchParams(window.location.search)
  const credentials = searchParameters.get('credentials') ?? undefined
  const token = searchParameters.get('token')

  if (!token) return undefined

  return {
    credentials,
    token,
    market: searchParameters.get('market') ?? '',
    language: searchParameters.get('language') ?? '',
  }
}

export interface RomaniaLaunchParameters {
  userId: string
}

export function getRomaniaLaunchParameters():
  | RomaniaLaunchParameters
  | undefined {
  const searchParameters = new URLSearchParams(window.location.search)
  const userId = searchParameters.get('userId')
  if (!userId) return undefined
  return { userId }
}

export interface BrazilLaunchParameters {
  firebaseToken: string
}

export function getBrazilLaunchParameters():
  | BrazilLaunchParameters
  | undefined {
  const windowContext = window as unknown as Record<string, unknown>
  const firebaseToken =
    getCookie('ext-token-id') ??
    windowContext['Token-Id'] ??
    windowContext['token-id']
  if (typeof firebaseToken !== 'string' || !firebaseToken) return undefined
  return { firebaseToken }
}
